import bannerCatchGame from 'src/modules/catchGame/assets/banner/banner_catchGame.webp';
import promoCatchGame from 'src/modules/catchGame/assets/banner/promo_catchGame.webp';
import bannerCardGame from 'src/modules/cardGame/assets/banner/banner_cardGame.webp';
import promoCardGame from 'src/modules/cardGame/assets/banner/promo_cardGame.webp';
import { isShowEvent } from 'src/config/event/utils';
import { EventGamesType } from 'src/config/event/types';

export const BANNER_SETTINGS = {
  CARD_GAME: {
    key: 'CARD_GAME',
    gameName: 'EASTER_SPINS',
    name: 'catch-game.cardGameNameSidebar',
    namePopup: 'catch-game.cardGameName',
    bannerImgSrc: bannerCardGame,
    promoImgSrc: promoCardGame,
    bgColor: 'bg-gb_card_game_banner_bg',
    bgPopupColor: 'bg-gb_catch_game_banner_popup_bg',
    checkShowBanner: () => isShowEvent('CARD_GAME')
  },
  CATCH_GAME: {
    key: 'CATCH_GAME',
    gameName: 'CATCH_EASTER_RABBIT',
    name: 'catch-game.catchGameNameSidebar',
    namePopup: 'catch-game.catchGameName',
    bannerImgSrc: bannerCatchGame,
    promoImgSrc: promoCatchGame,
    bgColor: 'bg-gb_catch_game_banner_bg',
    bgPopupColor: 'bg-gb_catch_game_banner_popup_bg',
    checkShowBanner: () => isShowEvent('CATCH_GAME')
  }
} satisfies Record<EventGamesType, object>;
